import authRequest from "@/api/http/authRequest";


export default {
  search (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.get(`/admin/product/lesson/option/search`, params, cb, errCb)
  },
  save (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.post(`/admin/product/lesson/option`, params ,cb, errCb)
  },
  updateStatus (id: number, cb: (response) => void, errCb: (response) => any) {
    authRequest.put(`/admin/product/lesson/option/${id}/status`, {} ,cb, errCb)
  },
  update (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.post(`/admin/product/lesson/option/${params.id}`, params ,cb, errCb)
  },
  delete (id: number, cb: (response) => void, errCb: (response) => any) {
    authRequest.delete(`/admin/product/lesson/option/${id}`, cb, errCb)
  },
}
